import { render, staticRenderFns } from "./SashType.vue?vue&type=template&id=4c9c5a61&scoped=true&"
import script from "./SashType.vue?vue&type=script&lang=js&"
export * from "./SashType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9c5a61",
  null
  
)

export default component.exports